import { render, staticRenderFns } from "./UserReferralReferralsReferrals.vue?vue&type=template&id=29da77f0&scoped=true&"
import script from "./UserReferralReferralsReferrals.vue?vue&type=script&lang=js&"
export * from "./UserReferralReferralsReferrals.vue?vue&type=script&lang=js&"
import style0 from "./UserReferralReferralsReferrals.vue?vue&type=style&index=0&id=29da77f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29da77f0",
  null
  
)

export default component.exports